import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
//Vendors
import Cookies from 'js-cookie';
// Types

import storageConstants from "../../constants/storage";
var getCookie = function getCookie(id) {
  return Cookies.get(id);
};
var setCookie = function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    domain = _ref.domain;
  var now = new Date();
  var time = now.getTime();
  var expireTime = time + 1000 * 3600;
  now.setTime(expireTime);
  Cookies.set(name, value, {
    domain: domain ? domain : '',
    path: '/',
    expires: now,
    secure: true
  });
};
var removeCookie = function removeCookie(_ref2) {
  var id = _ref2.id,
    _ref2$domain = _ref2.domain,
    domain = _ref2$domain === void 0 ? '' : _ref2$domain,
    _ref2$secure = _ref2.secure,
    secure = _ref2$secure === void 0 ? true : _ref2$secure;
  Cookies.remove(id, {
    path: '/',
    secure: secure,
    domain: domain
  });
};
var removeAllCookies = function removeAllCookies() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  removeCookie({
    id: storageConstants.COOKIES_IDS.ACCESS_TOKEN,
    domain: domain
  });
  removeCookie({
    id: storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN,
    domain: domain
  });
  removeCookie({
    id: storageConstants.COOKIES_IDS.REFRESH_TOKEN,
    domain: domain
  });
  removeCookie({
    id: storageConstants.COOKIES_IDS.AGENT_TOKEN,
    domain: domain
  });
  removeCookie({
    id: storageConstants.COOKIES_IDS.USERNAME,
    domain: domain
  });
  removeCookie({
    id: storageConstants.LOCALSTORAGE_IDS.REFRESH_TOKEN_ALIVE,
    domain: domain
  });
  removeCookie({
    id: storageConstants.LOCALSTORAGE_IDS.REMEMBER_USER,
    domain: domain
  });
};
export default {
  getCookie: getCookie,
  setCookie: setCookie,
  removeCookie: removeCookie,
  removeAllCookies: removeAllCookies
};